/*=========================================================================================
  File Name: getters.js
  Description: Products Getters
  ----------------------------------------------------------------------------------------
  Item Name: Product State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    categoriesFromProductsList: state => {
        let results = [];
        let map = new Map();

        for(let item of state.products) {
            if(!map.has(item.categoryId)) {
                map.set(item.categoryId, true);
                results.push({
                    categoryId : item.categoryId,
                    categoryName : item.category
                });
            }
        }
        //console.log(results)
        return results;
        
    },
    productsByCategoryId: state => id => {
        //console.log(id);
        if (id == null) {
            return [];
        }
        let products = state.products.filter(obj => {
            return obj.categoryId === id;
        })

        return products;
    },

    restaurantName: state => {
        //console.log(state.selectedRestaurantId)
        let index = state.restaurants.find(i => { return i.restaurantId === state.selectedRestaurantId });
        if(index > -1) {
            return state.restaurants[index].restaurantName;
        }
        else {
            return null;
        }
        
    }

   
}